
import React from 'react';
import { showActiveAlerts } from '@store/aiAlerts/summary/actions';
import { activeAlertsSelector } from '@store/aiAlerts/summary/selectors';
import { useSelector, useDispatch } from 'react-redux';
import {
  Wrapper, TagName, TagValue,
} from './styled';

const ActiveAlertsTag = ({ value }) => {
  const dispatch = useDispatch();
  const isActiveSelected = useSelector(activeAlertsSelector);

  const onClickOfTag = () => {
    if (isActiveSelected) {
      dispatch(showActiveAlerts(false));
    } else {
      dispatch(showActiveAlerts(true));
    }
  };

  return (
    <Wrapper isSelected={isActiveSelected} onClick={onClickOfTag}>
      <TagName>Active</TagName>
      <TagValue>
        {value}
      </TagValue>
    </Wrapper>
  );
};

export default ActiveAlertsTag;
